var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item transition-slow" }, [
    _c("div", { staticClass: "info-content" }, [
      _c(
        "div",
        { staticClass: "info-item" },
        [
          _c(
            "router-link",
            { staticClass: "return-link", attrs: { to: { name: "login" } } },
            [_c("span", { class: "fas fa-arrow-left" }), _vm._v(" Volver ")]
          ),
          _vm._m(0),
          _vm._m(1),
          _vm._m(2),
          _vm._m(3),
          _c(
            "a",
            {
              staticClass: "button is-button-primary transition-fast",
              attrs: { href: "https://ui.creditu.com/", target: "__BLANK" },
            },
            [_vm._v(" Simular ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-item" }, [
      _c("h2", { staticClass: "login-title" }, [_vm._v("¡Ingreso inválido!")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "message-box" }, [
      _c("p", [
        _vm._v("Usuario o contraseña son incorrectas, vuelve a intentarlo."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "developer" }, [
      _c("img", { attrs: { src: require("@/ui/assets/img/developer.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "message-box" }, [
      _c("p", [
        _vm._v(
          "Recuerda que puedes simular tu crédito hipotecario 100% online:"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }